import { render, staticRenderFns } from "./marketInspection.vue?vue&type=template&id=96bcb424&scoped=true"
import script from "./marketInspection.vue?vue&type=script&lang=js"
export * from "./marketInspection.vue?vue&type=script&lang=js"
import style0 from "./marketInspection.vue?vue&type=style&index=0&id=96bcb424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96bcb424",
  null
  
)

export default component.exports